import AbstractSystem from "../all/AbstractSystem";

class Ps4System extends AbstractSystem {
    exit() {
        window.open('/node/homeuser', '_self', '');
        window.close();
    }
}

export default Ps4System;



// WEBPACK FOOTER //
// ./src/devices/ps4/System.js